export default __webpack_public_path__ + "static/media/MIT-trans.39e8a91f.png";